// eslint-disable-next-line import/no-unresolved
import type { DocumentsHostConfig } from "@astrana/ui/documents";
// The lib bundles its own copy of @apollo/client so TypeScript sees two
// structurally-incompatible ApolloClient types. The cast below is safe at
// runtime — both module instances are the same version and share the same
// wire protocol; only the type-checker disagrees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
import type { ApolloClient } from "@apollo/client";
import { useCanUpdate } from "~/auth/useCanUpdate";
import { createGqlLlmClient } from "~/clinical/gqlLlmClient";
import { toast } from "sonner";

export function buildDocumentsHostConfig(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  apolloClient: ApolloClient<unknown>,
): DocumentsHostConfig {
  return {
    // Cast through unknown to reconcile the dual @apollo/client instance
    // types (app copy vs lib's bundled copy). Safe: same runtime package.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    apolloClient: apolloClient as unknown as DocumentsHostConfig["apolloClient"],
    // LLM calls proxy through care-management-gql; the Azure key stays
    // server-side and never enters this bundle.
    llmClient: createGqlLlmClient(apolloClient),
    useCanUpdate,
    navigateToSource: ({ code, sourceLocation }) => {
      // m360 has no in-app cross-doc navigation yet — toast for now.
      toast.info(`Source: ${sourceLocation ?? code}`);
    },
    toast: {
      success: (msg) => toast.success(msg),
      error: (msg) => toast.error(msg),
    },
  };
}
